import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M6.99996 3.5C6.99996 3.22386 6.7761 3 6.49996 3C6.22382 3 5.99996 3.22386 5.99996 3.5V4H5.49996C5.22382 4 4.99996 4.22386 4.99996 4.5C4.99996 4.77614 5.22382 5 5.49996 5H5.99996V5.5C5.99996 5.77614 6.22382 6 6.49996 6C6.7761 6 6.99996 5.77614 6.99996 5.5V5H7.49996C7.7761 5 7.99996 4.77614 7.99996 4.5C7.99996 4.22386 7.7761 4 7.49996 4H6.99996V3.5ZM12.4242 3.71716C12.1899 3.48284 11.81 3.48284 11.5757 3.71716L9.14641 6.14645L3.71712 11.5757C3.4828 11.8101 3.4828 12.1899 3.71712 12.4243L5.0757 13.7828C5.31001 14.0172 5.68991 14.0172 5.92422 13.7828L11.3535 8.35355L13.7828 5.92426C14.0171 5.68995 14.0171 5.31005 13.7828 5.07574L12.4242 3.71716ZM10.2071 6.5L12 4.70711L12.7929 5.5L11 7.29289L10.2071 6.5ZM9.49996 7.20711L10.2929 8L5.49996 12.7929L4.70707 12L9.49996 7.20711ZM4.99996 7.5C4.99996 7.77614 4.7761 8 4.49996 8C4.22382 8 3.99996 7.77614 3.99996 7.5C3.99996 7.22386 4.22382 7 4.49996 7C4.7761 7 4.99996 7.22386 4.99996 7.5ZM12.5 10C12.7761 10 13 9.77614 13 9.5C13 9.22386 12.7761 9 12.5 9C12.2238 9 12 9.22386 12 9.5C12 9.77614 12.2238 10 12.5 10Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
